import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStencylComponent } from './simple-icons-stencyl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStencylComponent ],
    exports:      [ SimpleIconsStencylComponent ],
    bootstrap:    []
})
export class SimpleIconsStencylModule {}
